<template>
  <ul class="legend">
    <li v-for="status in statuses" :key="status.name" class="legend-item">
      <span class="circle circle-common" :style="{ backgroundColor: status.color }"></span>
      <span class="label">{{ status.name }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ReservationStatusLegend',

  data () {
    return {
      statuses: [
        {
          name: this.$t('fleet/vehicle_reservation.all_day'),
          color: '#335a94'
        },
        {
          name: this.$t('fleet/vehicle_reservation.partial_day'),
          color: '#85b4e2'
        },
        {
          name: this.$t('fleet/vehicle_reservation.own_all_day'),
          color: '#17b017'
        },
        {
          name: this.$t('fleet/vehicle_reservation.own_partial_day'),
          color: '#92ff92'
        },
        {
          name: this.$t('fleet.deactivated'),
          color: '#ffb5b5'
        }
      ]
    }
  }
}
</script>

<style scoped>
@import "../styles/circleStyle.css";
.legend {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 16px; /* space between items */
  align-items: center;
  flex-wrap: wrap; /* wrap to next line if too long */
}

.legend-item {
  display: flex;
  align-items: center;
}

.circle {
  margin-right: 6px;
}

.label {
  font-size: 14px;
}
</style>
